import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import DateTime from 'react-datetime';
import * as moment from 'moment';
import TeamMemberForm from './TeamMemberForm';
import ContactItemForm from './ContactItemForm';
import ClientForm from './ClientForm';
import RolesGroup from '../RolesGroup';
import WYSIWYG from '../../../../components/forms/redux-form/WYSIWYG';

require('react-datetime/css/react-datetime.css');

class LocationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddMemberForm: false,
      showAddContactForm: false,
      showAddClientForm: false,
      radioOptions: [
        { id: "Onsite", name: "Onsite" },
        { id: "Nearsite", name: "Nearsite" }
      ]
    };

    this.addMemberClick = this.addMemberClick.bind(this);
    this.removeUser = this.removeUser.bind(this);
    this.addUser = this.addUser.bind(this);
    this.addClient = this.addClient.bind(this);
    this.removeClient = this.removeClient.bind(this);
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    help,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={label}
          type={type}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
        />
        <small className="help-block">{help}</small>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderRadioField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    help,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <Field
          name="siteType"
          value="siteType"
          component={RolesGroup}
          options={this.state.radioOptions}
        />
      </div>
    </div>
  );

  renderWYSIWYG = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <WYSIWYG input={input} />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderScheduleTimeField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className="col-sm-4">
      <div className="input-group">
        <input {...input} className="form-control" placeholder="12:00am" />
        {/* <span className="input-group-addon" onClick={openCalendar}>
          <i className="fa fa-clock-o" />
        </span> */}
      </div>
      {touched &&
        ((error && <small className="help-block">{error}</small>) ||
          (warning && <small className="help-block">{warning}</small>))}
    </div>
  );

  renderScheduleField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className="col-sm-2">
      <input
        {...input}
        className="form-control"
        placeholder={label}
        type={type}
        disabled={disabled}
        maxLength={maxLength}
      />
      {touched &&
        ((error && <small className="help-block">{error}</small>) ||
          (warning && <small className="help-block">{warning}</small>))}
    </div>
  );

  renderDateField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <DateTime
          // dateFormat="YYYY-MM-DD"
          timeFormat={false}
          viewDate={input.value}
          {...input}
          renderInput={(props, openCalendar, closeCalendar) => {
            const value =
              props.value && moment(props.value)
                ? moment(props.value).format('MM/DD/YYYY')
                : moment().format('MM/DD/YYYY');
            return (
              <div className="input-group">
                <input {...props} type="hidden" />
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  readOnly
                  onFocus={openCalendar}
                />
                <span className="input-group-addon" onClick={openCalendar}>
                  <i className="fa fa-calendar" />
                </span>
              </div>
            );
          }}
          renderDay={(props, currentDate, selectedDate) => {
            return <td {...props}>{currentDate.date()}</td>;
          }}
          onChange={param => {
            if (param) {
              // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
              input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
              // input.onChange(param)
            }
          }}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderSelect = ({
    input,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control">
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  addMemberClick = () =>
    this.setState({ showAddMemberForm: !this.state.showAddMemberForm });

  addUser = values => {
    const { teamNames, formValues } = this.props;

    const team = teamNames.filter(el => el.id === +values.team);

    const items = [...formValues.team];
    for (var i = 0; i < items.length; i++) {
      if (items[i].isDefault === values.isDefault) {
        alert("Only one default provider can be chosen.");
        return;
      }
    }
    if (team && values.user) {
      items.push({
        teamName: team[0].name,
        TeamNameID: team[0].id,
        UserID: values.user.id,
        firstName: values.user.firstName,
        lastName: values.user.lastName,
        hoursAssigned: values.hoursAssigned,
        isDefault: values.isDefault
      });
    }
    this.props.change('team', items);
    this.setState({ showAddMemberForm: !this.state.showAddMemberForm });
  };

  addClient = values => {
    const clinicLocationClients = [
      ...(this.props.formValues.clinicLocationClients ? this.props.formValues.clinicLocationClients : {}),
    ];
    const client = { ...values.client, ...values };
    delete client.team;
    clinicLocationClients.push(client);
    this.props.change('clinicLocationClients', clinicLocationClients);
    this.setState({ showAddClientForm: !this.state.showAddClientForm });
  };

  removeUser = (e, idx) => {
    const team = [...this.props.formValues.team];
    team.splice(idx, 1);
    this.props.change('team', team);
  };

  addContactClick = () =>
    this.setState({ showAddContactForm: !this.state.showAddContactForm });

  addClientClick = () =>
    this.setState({ showAddClientForm: !this.state.showAddClientForm });

  removeClient = (e, idx) => {
    const clinicLocationClients = [
      ...this.props.formValues.clinicLocationClients,
    ];
    clinicLocationClients.splice(idx, 1);
    this.props.change('clinicLocationClients', clinicLocationClients);
  };

  addContact = values => {
    const items = [...this.props.formValues.contacts];
    items.push(values);
    this.props.change('contacts', items);
    this.setState({ showAddContactForm: !this.state.showAddContactForm });
  };

  removeContact = (e, idx) => {
    const contacts = [...this.props.formValues.contacts];
    contacts.splice(idx, 1);
    this.props.change('contacts', contacts);
  };

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      //initialValues,
      isLoading,
      teamNames,
      activityStatuses,
      searchUsers,
      formValues,
      searchClients,
    } = this.props;
    const {
      showAddMemberForm,
      showAddContactForm,
      showAddClientForm,
    } = this.state;

    //const isAdd = initialValues.clinicLocationID === null;

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Location Information</legend>
          <Field
            className="form-control"
            name="siteName"
            component={this.renderField}
            type="text"
            label="Location Name"
          />
          <Field
            className="form-control"
            name="clinicLocationID"
            component={this.renderField}
            type="text"
            label="Clinic Location ID"
            disabled={true}
            maxLength={5}
          />
          <Field
            className="form-control"
            name="siteCode"
            component={this.renderField}
            type="text"
            label="Location Code"
            help="Location Code is used for reporting and should not include spaces or special characters - it is commonly the Hint Location ID as loc-XXXXXXXXX."
          />
          <Field
            className="form-control"
            name="practiceGroupName"
            component={this.renderField}
            type="text"
            label="Practice Group Name"
          />
          <Field
            className="form-control"
            name="siteDescription"
            component={this.renderField}
            type="text"
            label="Location Description"
            help="Brief summary of location. E.g., Onsite Health Center for ACME Corp HQ with Primary Care & Occ Health."
          />
          <Field
            className="form-control"
            name="elationPracticeId"
            component={this.renderField}
            type="text"
            label="EMR Location Unique ID"
            help="Expected values are the Elation practice ID or the Athena Department ID."
          />
          <Field
            className="form-control"
            name="DPC"
            component={this.renderSelect}
            type="text"
            label="DPC"
          >
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </Field>
          <Field
            className="form-control"
            name="statusID"
            component={this.renderSelect}
            type="text"
            label="Status"
          >
            {activityStatuses &&
              activityStatuses.map(el => (
                <option key={el.id} value={el.id}>
                  {el.name}
                </option>
              ))}
          </Field>
          <Field
            className="form-control"
            name="about"
            component={this.renderWYSIWYG}
            type="text"
            label="About"
          />
          {/*<Field*/}
          {/*  className="form-control"*/}
          {/*  name="latitude"*/}
          {/*  component={this.renderField}*/}
          {/*  type="text"*/}
          {/*  label="Latitude"*/}
          {/*/>*/}
          {/*<Field*/}
          {/*  className="form-control"*/}
          {/*  name="longitude"*/}
          {/*  component={this.renderField}*/}
          {/*  type="text"*/}
          {/*  label="Longitude"*/}
          {/*/>*/}
          <Field
            className="form-control"
            name="reciprocityAgreements"
            component={this.renderSelect}
            type="text"
            label="ReciprocityAgreements"
          >
            <option value="-1">Select</option>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </Field>
          <Field
            className="form-control"
            name="isShared"
            component={this.renderSelect}
            type="text"
            label="IsShared"
          >
            <option value="-1">Select</option>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </Field>
          <Field
            className="form-control"
            name="siteType"
            value="siteType"
            component={this.renderRadioField}
            label="Site Type"
          />
        </fieldset>
        <fieldset>
          <legend>Address</legend>
          <Field
            className="form-control"
            name="address1"
            component={this.renderField}
            type="text"
            label="Address 1"
          />
          <Field
            className="form-control"
            name="address2"
            component={this.renderField}
            type="text"
            label="Address 2"
          />
          <Field
            className="form-control"
            name="city"
            component={this.renderField}
            type="text"
            label="City"
          />
          <Field
            className="form-control"
            name="state"
            component={this.renderField}
            type="text"
            label="State"
            maxLength={2}
          />
          <Field
            className="form-control"
            name="zip"
            component={this.renderField}
            type="text"
            label="Zip"
            maxLength={5}
          />
          <Field
            className="form-control"
            name="completeAddress"
            component={this.renderField}
            type="text"
            label="Complete Address"
            readOnly={true}
          />
          <Field
            className="form-control"
            name="startDate"
            component={this.renderDateField}
            type="text"
            label="Start Date"
          />
          <Field
            className="form-control"
            name="phoneNumber"
            component={this.renderField}
            type="text"
            label="Phone Number"
          />
          <Field
            className="form-control"
            name="fax"
            component={this.renderField}
            type="text"
            label="Fax"
          />
        </fieldset>
        <fieldset>
          <legend>Schedule</legend>
          {/* <Field
            className="form-control"
            name="weeklyHours"
            component={this.renderField}
            type="text"
            label="Weekly Hours"
          /> */}
          <Field
            className="form-control"
            name="siteNumber"
            component={this.renderField}
            type="text"
            label="Pharmacy Site ID"
            help="This is typically the 5-digit A-S Meds site ID and is used for reporting to match dispensing logs."
          />
          <div className={`form-group`}>
            <label className="col-md-2 control-label">Monday</label>
            <Field
              className="form-control"
              name="schedule.mondayOpen"
              component={this.renderScheduleTimeField}
              type="text"
              label="Open"
            />
            <Field
              className="form-control"
              name="schedule.mondayClose"
              component={this.renderScheduleTimeField}
              type="text"
              label="Close"
            />
            <Field
              className="form-control"
              name="schedule.monday"
              component={this.renderScheduleField}
              type="text"
              label="Hours"
            />
          </div>
          <div className={`form-group`}>
            <label className="col-md-2 control-label">Tuesday</label>
            <Field
              className="form-control"
              name="schedule.tuesdayOpen"
              component={this.renderScheduleTimeField}
              type="text"
              label="Open"
            />
            <Field
              className="form-control"
              name="schedule.tuesdayClose"
              component={this.renderScheduleTimeField}
              type="text"
              label="Close"
            />
            <Field
              className="form-control"
              name="schedule.tuesday"
              component={this.renderScheduleField}
              type="text"
              label="Hours"
            />
          </div>
          <div className={`form-group`}>
            <label className="col-md-2 control-label">Wednesday</label>
            <Field
              className="form-control"
              name="schedule.wednesdayOpen"
              component={this.renderScheduleTimeField}
              type="text"
              label="Open"
            />
            <Field
              className="form-control"
              name="schedule.wednesdayClose"
              component={this.renderScheduleTimeField}
              type="text"
              label="Close"
            />
            <Field
              className="form-control"
              name="schedule.wednesday"
              component={this.renderScheduleField}
              type="text"
              label="Hours"
            />
          </div>
          <div className={`form-group`}>
            <label className="col-md-2 control-label">Thursday</label>
            <Field
              className="form-control"
              name="schedule.thursdayOpen"
              component={this.renderScheduleTimeField}
              type="text"
              label="Open"
            />
            <Field
              className="form-control"
              name="schedule.thursdayClose"
              component={this.renderScheduleTimeField}
              type="text"
              label="Close"
            />
            <Field
              className="form-control"
              name="schedule.thursday"
              component={this.renderScheduleField}
              type="text"
              label="Hours"
            />
          </div>
          <div className={`form-group`}>
            <label className="col-md-2 control-label">Friday</label>
            <Field
              className="form-control"
              name="schedule.fridayOpen"
              component={this.renderScheduleTimeField}
              type="text"
              label="Open"
            />
            <Field
              className="form-control"
              name="schedule.fridayClose"
              component={this.renderScheduleTimeField}
              type="text"
              label="Close"
            />
            <Field
              className="form-control"
              name="schedule.friday"
              component={this.renderScheduleField}
              type="text"
              label="Hours"
            />
          </div>
          <div className={`form-group`}>
            <label className="col-md-2 control-label">Suturday</label>
            <Field
              className="form-control"
              name="schedule.saturdayOpen"
              component={this.renderScheduleTimeField}
              type="text"
              label="Open"
            />
            <Field
              className="form-control"
              name="schedule.saturdayClose"
              component={this.renderScheduleTimeField}
              type="text"
              label="Close"
            />
            <Field
              className="form-control"
              name="schedule.saturday"
              component={this.renderScheduleField}
              type="text"
              label="Hours"
            />
          </div>
          <div className={`form-group`}>
            <label className="col-md-2 control-label">Sunday</label>
            <Field
              className="form-control"
              name="schedule.sundayOpen"
              component={this.renderScheduleTimeField}
              type="text"
              label="Open"
            />
            <Field
              className="form-control"
              name="schedule.sundayClose"
              component={this.renderScheduleTimeField}
              type="text"
              label="Close"
            />
            <Field
              className="form-control"
              name="schedule.sunday"
              component={this.renderScheduleField}
              type="text"
              label="Hours"
            />
          </div>
        </fieldset>
        <fieldset>
          <legend>
            Team{' '}
            <a
              className={`btn btn-xs btn-default ${
                showAddMemberForm ? 'active' : ''
              }`}
              onClick={this.addMemberClick}
            >
              <i className="fa fa-plus" /> Add Team Member
            </a>
          </legend>
          {showAddMemberForm && (
            <TeamMemberForm
              teamNames={teamNames}
              searchUsers={searchUsers}
              onSubmit={this.addUser}
            />
          )}
          {formValues && formValues.team && formValues.team.length > 0 && (
            <div className="row form-group">
              <div className="col-md-2 control-label">Team Members</div>
              <div className="col-md-10">
                <ul className="list-group">
                  {formValues &&
                    formValues.team &&
                    formValues.team.map((el, idx) => (
                      <li key={idx} className="list-group-item">
                        <img
                          src="/assets/img/avatars/sunny.png"
                          alt="user"
                          width="20px"
                        />
                        {` `}
                        <strong>
                          {el.firstName}
                          {` `}
                          {el.lastName}
                        </strong>
                        {` `}
                        <em>({el.teamName})</em>
                        {(el.hoursAssigned !== 0) &&
                          <em>({el.hoursAssigned})</em>
                        }
                        {` `}
                        <em>{el.isDefault ? 'Default Provider' : ''}</em>
                        <a
                          onClick={e => this.removeUser(e, idx)}
                          className="btn btn-default btn-xs pull-right"
                        >
                          &times;
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          )}
        </fieldset>
        <fieldset>
          <legend>
            Contacts{' '}
            <a
              className={`btn btn-xs btn-default ${
                showAddContactForm ? 'active' : ''
              }`}
              onClick={this.addContactClick}
            >
              <i className="fa fa-plus" /> Add Contact
            </a>
          </legend>
          {showAddContactForm && <ContactItemForm onSubmit={this.addContact} />}
          {formValues && formValues.contacts && formValues.contacts.length > 0 && (
            <div className="row form-group">
              <div className="col-md-2 control-label">Contacts</div>
              <div className="col-md-10">
                <ul className="list-group">
                  {formValues &&
                    formValues.contacts &&
                    formValues.contacts.map((el, idx) => (
                      <li key={idx} className="list-group-item">
                        <strong>{el.type}</strong>
                        {`: `}
                        <span>{el.contact}</span>
                        {` `}
                        <em>({el.description})</em>
                        <a
                          onClick={e => this.removeContact(e, idx)}
                          className="btn btn-default btn-xs pull-right"
                        >
                          &times;
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          )}
        </fieldset>
        <fieldset>
          <legend>
            Clients{' '}
            <a
              className={`btn btn-xs btn-default ${
                showAddClientForm ? 'active' : ''
              }`}
              onClick={this.addClientClick}
            >
              <i className="fa fa-plus" /> Add Client
            </a>
          </legend>
          {showAddClientForm && (
            <ClientForm
              teamNames={teamNames}
              searchClients={searchClients}
              onSubmit={this.addClient}
            />
          )}
          {formValues &&
            formValues.clinicLocationClients &&
            formValues.clinicLocationClients.length > 0 && (
              <div className="row form-group">
                <div className="col-md-2 control-label">Clients</div>
                <div className="col-md-10">
                  <ul className="list-group">
                    {formValues &&
                      formValues.clinicLocationClients &&
                      formValues.clinicLocationClients.map((el, idx) => (
                        <li key={idx} className="list-group-item">
                          <img
                            src="/assets/img/avatars/sunny.png"
                            alt="user"
                            width="20px"
                          />
                          {` `}
                          <strong>{el.employerCodeDescription} ({el.employerCodeNumber})</strong>
                          {` `}
                          <em>{el.isDefault ? 'Default' : ''}</em>
                          {` `}
                          <em>{el.isAnchorTenant ? 'Anchor' : ''}</em>
                          {` `}
                          <a
                            onClick={e => this.removeClient(e, idx)}
                            className="btn btn-default btn-xs pull-right"
                          >
                            &times;
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            )}
        </fieldset>
        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              {/* <button className="btn btn-default" type="button" disabled={pristine || submitting} onClick={reset}>
                Reset</button>{" "} */}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="cover">
            <div className="spinner inline" />
          </div>
        )}
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  const required = [
    'siteName',
    'clinicLocationID',
    'siteCode',
    //'practiceGroupName',
    //'siteDescription',
    'DPC',
    'siteType'
  ];

  const scheduleFields = [
    'fridayClose',
    'fridayOpen',
    'mondayClose',
    'mondayOpen',
    'saturdayClose',
    'saturdayOpen',
    'sundayClose',
    'sundayOpen',
    'thursdayClose',
    'thursdayOpen',
    'tuesdayClose',
    'tuesdayOpen',
    'wednesdayClose',
    'wednesdayOpen',
  ];

  required.forEach(el => {
    if (!values[el]) {
      errors[el] = 'Required';
    }
  });
  if (values.schedule) {
    errors['schedule'] = {};
    scheduleFields.forEach(el => {
      if (values['schedule'][el]) {
        if (
          !/\b((1[0-2]|0?[1-9]):([0-5][0-9])([AaPp][Mm]))/.test(
            values['schedule'][el],
          )
        ) {
          errors['schedule'][el] = 'Wrong format';
        }
      }
    });
  }
  return errors;
};

LocationForm = connect(state => ({
  formValues: getFormValues('location')(state),
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'location' })(LocationForm));
export default LocationForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/location/LocationForm.js